import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { taskService } from '../api/taskService';
import { DIVISIONS } from '../constants/divisions';
import { userService } from '../api/userService';
import AnalyticsWidgets from '../components/AnalyticsWidgets';
import ContentLoader from '../components/ContentLoader';
import { getUserName } from '../utils/userUtils';


const DGAnalyticsDashboard = () => {


    const { data: allTasks = [], isLoading: loadingTasks, error: taskError } = useQuery({
        queryKey: ['dg_analytics_tasks'],
        queryFn: taskService.getAllTasks,
        staleTime: 60000,
    });

    const { data: usersData = [], isLoading: loadingUsers } = useQuery({
        queryKey: ['users'],
        queryFn: () => userService.getAllUsers().catch(() => []),
        staleTime: 300000,
    });

    const tasks = allTasks || [];
    const users = Array.isArray(usersData) ? usersData : (usersData?.Users || []);
    const loading = loadingTasks || loadingUsers;
    const error = taskError ? 'Failed to load analytics data.' : null;

    if (loading) return <ContentLoader text="Loading DG Analytics..." />;
    if (error) return <div style={{ padding: '2rem', color: 'red' }}>{error}</div>;

    return (
        <div style={{ padding: '1rem 3rem', maxWidth: '1800px', margin: '0 auto' }}>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
                {DIVISIONS.map(divisionObj => {
                    const division = divisionObj.id;
                    const divisionTasks = tasks.filter(t => t.Division === division);
                    const color = divisionObj.color || '#999';


                    return (
                        <div key={division} style={{
                            background: 'white',
                            padding: '1.5rem',
                            borderRadius: '16px',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                            border: '1px solid #f0f0f0'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
                                <div style={{ width: '4px', height: '24px', background: color, borderRadius: '2px' }}></div>
                                <h3 style={{ margin: 0, fontSize: '1.4rem', color: '#202124', fontWeight: 600 }}>{divisionObj.name}</h3>
                                <span style={{
                                    background: '#f1f3f4', padding: '0.2rem 0.6rem', borderRadius: '12px',
                                    fontSize: '0.85rem', color: '#5f6368', fontWeight: 500
                                }}>
                                    {divisionTasks.length} Tasks
                                </span>
                            </div>

                            <div style={{ height: '220px' }}>
                                <AnalyticsWidgets
                                    tasks={divisionTasks}
                                    getUserName={(id) => getUserName(id, users)}
                                    users={users}
                                    activeDivision={division}
                                    layout="horizontal" // Use the new 4-column layout
                                />
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default DGAnalyticsDashboard;
